export function initUI() {
  document.addEventListener("click", (event) => {
    const toggleElement = event.target.closest("[data-mvthru-toggle]");
    if (!toggleElement) return;

    const targetId = toggleElement.getAttribute("data-mvthru-toggle");
    const targetElement = document.getElementById(targetId);

    if (!targetElement) return;

    targetElement.classList.toggle("active");
  });
}
